import { useEffect, useRef, useState } from 'react';
import { cookieUtils } from 'helpers/cookiesUtils';
import { checkIsTherapist } from 'helpers/checkIsTherapist';
import {
    initializeOneSignal,
    checkNotificationPermission,
    requestNotificationPermission,
    setupNotificationClickHandler,
    oneSignalLogin,
} from 'helpers/oneSignalUtils';
import useRegisterGuest from './useRegiterGuest';


/**
 * @param {string} appId - OneSignal App ID for the current site (guest or therapist)
 */
export const useOneSignal = (appId) => {
    const { guestId } = useRegisterGuest();
    const isTherapist = checkIsTherapist();
    const { getCookies } = cookieUtils;
    const cookies = getCookies();
    const userId = cookies?.user?.id;
    const initAttempted = useRef(false);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (!appId || initAttempted.current) return;
        initAttempted.current = true;

        const init = async () => {
            try {
                await initializeOneSignal(appId);

                const hasPermission = await checkNotificationPermission();
                if (!hasPermission) {
                    await requestNotificationPermission();
                }

                await setupNotificationClickHandler();
                setIsReady(true);
            } catch (error) {
                console.error('[useOneSignal] Initialization failed:', error);
                initAttempted.current = false;
            }
        };

        init();
    }, [appId]);

    useEffect(() => {
        if (!isReady) return;

        const login = async () => {
            try {
                if (userId && isTherapist) {
                    await oneSignalLogin(userId);
                } else if (guestId && !isTherapist) {
                    await oneSignalLogin(guestId);
                }
            } catch (error) {
                console.error('[useOneSignal] Login failed:', error);
            }
        };

        login();
    }, [isReady, guestId, userId, isTherapist]);
};
